import React from "react";
import { kennungStelle } from "../utils/targetName";

// Zeigt den vom Server gelieferten Zielnamen unverändert an und hebt die Werkskennung an der
// Stelle hervor, an der sie eingefügt wird (gleiche Gestaltung wie die Kennung im Werks-Tab).
// Ist keine eindeutige Stelle findbar, erscheint der Name ohne Hervorhebung.
export default function TargetName({ source, target, kennung }) {
  const at = kennungStelle(source, target, kennung);
  if (!at) return <>{target}</>;
  return <>{target.slice(0, at.start)}<span className="ken">{target.slice(at.start, at.end)}</span>{target.slice(at.end)}</>;
}
